import type RouterService from '@ember/routing/router-service';
import type { NavigateFunction } from '../types';
import { useCallback } from 'react';
import { useEmberService } from '@qonto/react-migration-toolkit/react/hooks';

export function useEmberNavigate(): NavigateFunction {
  // oxlint-disable-next-line @repo/no-use-ember-service-router, typescript/consistent-type-assertions
  const router = useEmberService('router') as RouterService;

  return useCallback(
    (to, options) => {
      const url = new URL(
        typeof to === 'string' ? to : (to.pathname ?? ''),
        window.location.origin
      );

      if (typeof to !== 'string') {
        url.search = new URLSearchParams(to.search).toString();
      }

      const routerMethod = options?.replace ? 'replaceWith' : 'transitionTo';

      router[routerMethod](`${url.pathname}${url.search}`);
    },
    [router]
  );
}
